import { FC, Fragment } from "react"
import { Title } from "../../../../../../_webui/layout/components/Typography/Title"
import { PreLine } from "../../../../../../_webui/layout/components/Typography/PreLine"
import { Translate } from "../../../../../../constant/Translate"
import { ButtonGroup } from "../../../../../../_webui/layout/components/Button/Group"
import { AttentionTitleType } from "./models"

const { TEXT_T359, TEXT_T360, TEXT_T310, TEXT_T311, TEXT_T366 } = Translate

export const AttentionTitle: FC<AttentionTitleType> = (props) => {
  const { isHiddenCopyBtn, onCopy, onEdit } = props

  return (
    <Fragment>
      <Title titleLeft={<PreLine>{TEXT_T359}</PreLine>} />
      <Title titleLeft={TEXT_T360} />
      <Title
        alignItems="flex-end"
        titleLeft={TEXT_T366}
        titleRight={
          <ButtonGroup
            buttonItems={[
              {
                isHidden: isHiddenCopyBtn,
                onClick: onCopy,
                order: 1,
                text: TEXT_T310,
              },
              {
                isHidden: isHiddenCopyBtn,
                onClick: onEdit,
                order: 2,
                text: TEXT_T311,
              },
            ]}
            isMargin={false}
          />
        }
      />
    </Fragment>
  )
}
